import { WidgetsListComponent } from './pages/users/edit-user/widgets-list/widgets-list.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './pages/login/login.component';
import { MainComponent } from './pages/main/main.component';
import { UsersComponent } from './pages/users/users.component';
import { RolesComponent } from './pages/roles/roles.component';
import { FoldersComponent } from './pages/folders/folders.component';
import { UsersListComponent } from './pages/users/users-list/users-list.component';
import { RolesListComponent } from './pages/roles/roles-list/roles-list.component';
import { MioComponent } from './pages/mio/mio.component';
import { EditUserComponent } from './pages/users/edit-user/edit-user.component';
import { ReportsListComponent } from './pages/users/edit-user/reports-list/reports-list.component';
import { FoldersListComponent } from './pages/users/edit-user/folders-list/folders-list.component';
import { UsersFgjsComponent } from './pages/users-fgjs/users-fgjs.component';
import { UsersFgjsListComponent } from './pages/users-fgjs/users-fgjs-list/users-fgjs-list.component';
import { UsersDpmComponent } from './pages/users-dpm/users-dpm.component';
import { UsersDpmListComponent } from './pages/users-dpm/users-dpm-list/users-dpm-list.component';



const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  {
    path: 'main', component: MainComponent, children: [
      {
        path: 'users', component: UsersComponent, children: [
          { path: 'list', component: UsersListComponent },
          {
            path: 'list/:id', component: EditUserComponent, children: [
              { path: '', redirectTo: 'folders', pathMatch: 'full' },
              { path: 'folders', component: FoldersListComponent },
              { path: 'dashboards/:folderId', component: ReportsListComponent },
              { path: 'widgets/:reportId', component: WidgetsListComponent }

            ]
          },
        ]
      },
      {
        path: 'roles', component: RolesComponent, children: [
          { path: 'list', component: RolesListComponent },
        ]
      },
      { path: 'folders', component: FoldersComponent },
      { path: 'mio', component: MioComponent },
      { 
        path: 'users-fgjs', component: UsersFgjsComponent, children: [
        { path: 'list', component: UsersFgjsListComponent },
      ] 
      },
      { 
        path: 'users-dpm', component: UsersDpmComponent, children: [
          { path: 'list', component: UsersDpmListComponent },
        ] 
      },
      { path: 'ik-employee', loadComponent: () => import('./pages/ik-employee/ik-employee.component').then(m => m.IkEmployeeComponent) },
      { path: 'ik-manager', loadComponent: () => import('./pages/ik-manager/ik-manager.component').then(m => m.IkManagerComponent) },
    ]
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
